import styled from 'styled-components'

export const StarRatingStyled = styled.div`
  position: relative;
  height: 15px;
  min-width: 80px;

  svg {
    width: 15px;
    height: 100%;
    margin: 0 1px 0 0;
  }
`



// WEBPACK FOOTER //
// ./src/Components/StarRating/style.js